<mat-notification @animatedNotificationCard *ngFor="let notification of notificationService.notifications" 
	[notification]="notification" elevation="8" (onClose)="notification.close()"></mat-notification>
